import React from 'react';
import LoginV3Layout from './LoginV3Layout';
import LoginV3FormCard from './LoginV3FormCard';
import LoginV3DepartmentCard from './LoginV3DepartmentCard';
import LoginV3EmployeeCard from './LoginV3EmployeeCard';
import LoginV3AccessCodeCard from './LoginV3AccessCodeCard';
import LoginV3ResetEmailCard from './LoginV3ResetEmailCard';
import LoginV3ResetOtpCard from './LoginV3ResetOtpCard';
import LoginV3ResetPasswordCard from './LoginV3ResetPasswordCard';
import LoginV3ResetSuccessCard from './LoginV3ResetSuccessCard';
import { useLoginV3Flow } from './LoginV3FlowProvider';

export default function LoginV3FlowView() {
    const { state } = useLoginV3Flow();
    const { step } = state;

    const isListStep = step === 'department' || step === 'employee';

    let card: React.ReactNode = null;
    switch (step) {
        case 'login':
            card = <LoginV3FormCard />;
            break;
        case 'department':
            card = <LoginV3DepartmentCard />;
            break;
        case 'employee':
            card = <LoginV3EmployeeCard />;
            break;
        case 'accessCode':
            card = <LoginV3AccessCodeCard />;
            break;
        case 'resetEmail':
            card = <LoginV3ResetEmailCard />;
            break;
        case 'resetOtp':
            card = <LoginV3ResetOtpCard />;
            break;
        case 'resetConfirm':
            card = <LoginV3ResetPasswordCard />;
            break;
        case 'resetSuccess':
            card = <LoginV3ResetSuccessCard />;
            break;
        default:
            card = <LoginV3FormCard />;
    }

    return (
        <LoginV3Layout
            maxWidthClassName={isListStep ? 'max-w-[500px]' : 'max-w-[480px]'}
            contentClassName={isListStep ? 'max-h-[90vh] sm:max-h-none' : undefined}
        >
            {card}
        </LoginV3Layout>
    );
}
